/**
 * Created by sunjinyu on 2018/11/27.
 */
export default {
  methods: {
    handlerError (e) {
      if (!e) {
        return;
      }
      if (!e.response || !e.response.data) {
        return;
      }
      let res = e.response.data;
      if (res.status === 110) {
        this.$toast(this.$t('common.network-failed'));
        return
      }
      if (`error.${res.error}` !== this.$t(`error.${res.error}`)) {
        return this.$t(`error.${res.error}`)
      } else if (res.msg) {
        return res.msg
      } else {
        return res
      }
    },
    locationRoot(suffix) {
      let protocol = window.location.protocol;
      if (protocol.indexOf(':') < 0) {
        protocol += ':';
      }
      let domain = document.domain;
      let port = window.location.port;
      let href = `${protocol}//${domain}`
      if (port && port !== 80 && port !== '80') {
        href += `:${port}`;
      }
      console.log(href)
      return href + suffix;
    },
    forbidBodyScroll () {
      document.getElementById('app').style.overflow = 'hidden';
    },
    allowBodyScroll () {
      document.getElementById('app').style.overflow = '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/index.js